<template>
  <div class="login">
    <div class="loginTitle">
      <i18n path="LOGIN.TITLE">
        <br />
      </i18n>
    </div>
    <div class="loginSubtitle">{{ $t(loginSubtitle) }}</div>
    <b-form @submit.prevent="login">
      <b-form-input v-model="username" class="formInput" :placeholder="$t(generalEmail)" @keyup.enter.native="login"></b-form-input>

      <b-form-input
        v-model="password"
        class="formInput"
        :placeholder="$t(generalPassword)"
        type="password"
        @keyup.enter.native="login"
      ></b-form-input>
    </b-form>
    <div class="error">
      <span v-if="loginError === 'credentials'">{{ $t(loginErrorCredenitals) }}</span>
      <span v-else-if="loginError === 'no_project'">{{ $t(loginErrorNoProject) }}</span>
      <span v-else-if="loginError">{{ $t(loginErrorOther) }}</span>
    </div>
    <div class="loginButtonRow">
      <b-button type="submit" style="font-size: 10px" @click="login">{{ $t(loginButton) }}</b-button>
      <loading :active.sync="isLoading" :can-cancel="false"></loading>
    </div>
  </div>
</template>

<script>
import axios from '../../../axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions } from 'vuex'

export default {
  name: 'LoginComponent',
  components: {
    Loading
  },

  data() {
    return {
      loginSubtitle: 'LOGIN.PLEASE_LOG_IN',
      generalEmail: 'GENERAl.EMAIL',
      generalPassword: 'GENERAl.PASSWORD',
      loginButton: 'LOGIN.LOG_IN',
      changePasswordButton: 'LOGIN.CHANGE_PASSWORD',
      loginErrorCredenitals: 'LOGIN.ERROR.CREDENTIALS',
      loginErrorOther: 'LOGIN.ERROR.OTHER',
      loginErrorNoProject: 'LOGIN.ERROR.NO_PROJECT',

      username: '',
      password: '',
      loginError: '',

      isLoading: false
    }
  },
  methods: {
    ...mapActions('authentication', ['fetchUserInformations', 'fetchProjectId', 'fetchStartDateOfProject', 'fetchProjectName']),
    async fetchProfileData() {
      await this.fetchUserInformations()
      await this.fetchProjectId()
      await this.fetchStartDateOfProject()
      await this.fetchProjectName()
    },
    changePassword() {
      this.$router.push('/server/accounts/password_change/')
    },
    /**
     * Attemps to login the user with given credentials.
     * Will set loginError variable on failed login, to display error.
     */
    async login() {
      this.isLoading = true
      try {
        const response = await axios.post(
          'api/user/login/',
          {
            username: this.username,
            password: this.password
          },
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        )

        if (response.status === 200) {
          localStorage.setItem('token', response.data.token)
          axios.defaults.headers.common.Authorization = `token ${response.data.token}`

          await this.fetchProfileData()

          this.$store.state.loggedIn = true

          const isViewer = this.$store.getters['authentication/getIsViewer']
          const isSupervisor = this.$store.getters['authentication/getIsSupervisor']
          const isAdministrator = this.$store.getters['authentication/getIsAdministrator']
          const hasProject = !!this.$store.getters['authentication/getProjectId']

          if (isViewer || isSupervisor || isAdministrator || hasProject) {
            this.$router.push('dashboard')
          } else {
            this.$router.push('projectApplication')
            this.isLoading = false
          }
        }
      } catch (error) {
        this.isLoading = false
        if (error.toString().includes('401')) {
          this.loginError = 'credentials'
        } else {
          this.loginError = 'other'
        }
      }
    }
  }
}
</script>

<style>
.login {
  border: solid 2px rgb(128, 128, 128);
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  border-radius: 10px;
  height: fit-content;
}

.loginTitle {
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  color: #8b69a9;
  padding-bottom: 15px;
}

.loginSubtitle {
  text-align: center;
  color: #8b69a9;
  font-weight: 600;
  padding-bottom: 20px;
  padding-right: 10px;
  padding-left: 10px;
  font-size: 10px;
}

.loginButtonRow {
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
}

.changeButton {
  background-color: white !important;
  color: #8b69a9;
}

.formInput {
  margin-bottom: 20px;
}

.error {
  text-align: center;
  max-width: fit-content;
  width: initial;
  line-break: strict;
  color: red;
}
</style>
